<div>
  <cloudlabs-note *ngFor="let note of notes" [note]="note" [htmlContent]="htmlString"></cloudlabs-note>
</div>
